import { render, staticRenderFns } from "./PhysicalPersonForm.vue?vue&type=template&id=1230e510"
import script from "./PhysicalPersonForm.vue?vue&type=script&lang=js"
export * from "./PhysicalPersonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports